<template>
  <div>
    <OperatorForm type="create" />
  </div>
</template>

<script>
import OperatorForm from "./OperatorForm.vue";
export default {
  name: "CreateOperator",
  components: {
    OperatorForm
  }
};
</script>
